<template>
	<div class="transferencia-butaca-page" style="position: relative;">
		<div class="transferencia-butaca-header">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>{{ espectaculo.tipoNombre }}</span>
					</div>
				</div>
				<div class="header-row" v-if="espectaculo.requiereInstituciones">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<img :src="espectaculo.institucionLocalEscudo" :alt="espectaculo.institucionLocalNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionLocalNombre }}</span>
							<span class="vs">vs</span>
						</div>
						<div class="header-equipo header-equipo-visitante">
							<img :src="espectaculo.institucionVisitanteEscudo" :alt="espectaculo.institucionVisitanteNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionVisitanteNombre }}</span>
						</div>
					</div>
				</div>
				<div v-else>
					{{ espectaculo.nombre }}
				</div>
			</div>
		</div>
		<div class="transferencia-butaca-main">
			<div class="container">
				<div class="transferencia-left">
					<h1>Transferencia de butaca</h1>
					<p class="subtitle">Complete la información de la transferencia de butaca</p>
					<div class="transferencia-content-row">
						<div class="butaca-dueno">
							<div class="row row-border-bottom">
								<span class="nro-ticket">Transferencia de butaca</span>
							</div>
							<div class="row row-info">
								<span class="title">Datos del titular</span>
							</div>
							<div class="row">
								<div class="row-group">
									<span class="label">Tipo de documento</span>
									<multiselect v-model="duenio.documentoTipo" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="row-group">
									<span class="label">Documento <info-icon tabindex="-1" content="Sin puntos ni guiones, ej. 12345678" v-tippy="{ placement : 'top'}"></info-icon></span>
									<input type="text" placeholder="Ej. 12345678" v-model="duenio.documento">
								</div>
							</div>
							<div class="row">
								<div class="row-group">
									<span class="label">Código de butaca</span>
									<input type="text" v-model="duenio.butacaNro" @keypress="soloNumeros">
								</div>
								<div class="row-group">
									<span class="label">PIN</span>
									<input type="text" v-model="duenio.pin" @keypress="soloNumeros">
								</div>
							</div>
							<div class="row">
								<span class="atencion-pin">Atención: el código y PIN de butaca se encuentra en el pdf de la butaca, el cual fue enviado por correo.</span>
							</div>
						</div>
						<div class="switch">
							<img src="../../assets/transferencia.svg" alt="">
						</div>
						<div class="butaca-acreedor">
							<div class="row row-border-bottom">
								<span class="nro-ticket">Transferencia de butaca</span>
							</div>
							<div class="row row-info">
								<span class="title">Datos del beneficiario</span>
							</div>
							<div class="row">
								<div class="row-group row-group-100">
									<span class="label">Preselección de persona</span>
									<multiselect v-model="preseleccionPersona" :options="preselecciones" @input="cambioPreseleccion()" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="(No utilizar preselección de persona)" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró preselección.</span>
										<span slot="noOptions">No hay preselecciones disponibles.</span>
									</multiselect>
								</div>
							</div>
							<div class="row">
								<div class="row-group">
									<span class="label">Nombre</span>
									<input type="text" v-model="acreedor.nombre" :disabled="esPreseleccion">
								</div>
								<div class="row-group">
									<span class="label">Apellido</span>
									<input type="text" v-model="acreedor.apellido" :disabled="esPreseleccion">
								</div>
							</div>
							<div class="row">
								<div class="row-group">
									<span class="label">Tipo de documento</span>
									<multiselect v-model="acreedor.documentoTipo" :options="tipoDocumentos" :disabled="esPreseleccion" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="row-group">
									<span class="label">Documento <info-icon tabindex="-1" content="Sin puntos ni guiones, ej. 12345678" v-tippy="{ placement : 'top'}"></info-icon></span>
									<input type="text" placeholder="Sin puntos ni guiones. Ej 12345678" v-model="acreedor.documento" :disabled="esPreseleccion">
								</div>
							</div>
							<!-- <div class="row">
								<div class="row-group">
									<span class="label">Teléfono</span>
									<input type="text" v-model="acreedor.telefono" @keypress="soloNumeros" :disabled="esPreseleccion">
								</div>
								<div class="row-group">
									<span class="small-text">Por disposición del MSP, es obligatorio ingresar el número de teléfono del espectador</span>
								</div>
							</div> -->
						</div>
					</div>
					<p style="margin-bottom: 15px;" class="full-info-title">Información del espectáculo</p>
					<div class="info-espectaculo full-info-main">
						<div class="competencia">
							<div class="competencia-info">
								<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
								<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
							</div>
							<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
						</div>
						<div class="fecha" v-if="espectaculo.requiereInstituciones">
							<span class="fecha-title">Fecha</span>
							<div class="fecha-content">
								<div class="fecha-texto">
									<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
									<p>{{ espectaculo.fechaEscrita }}</p>
								</div>
								<div class="fecha-hora">
									{{ espectaculo.hora }}
								</div>
							</div>
						</div>
						<div class="lugar">
							<span class="lugar-title">Lugar</span>
							<div class="lugar-content">
								<div class="lugar-content-left">
									<div class="lugar-info">
										<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
										<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
									</div>
									<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre" v-if="espectaculo.escenarioLogo">
								</div>
								<div class="ver-mapa" content="Ver ubicación" tabindex="-1" v-tippy="{ placement : 'bottom'}">
									<a :href="espectaculo.escenarioMapaURL" tabindex="-1" target="_blank"><map-icon></map-icon></a>
								</div>
							</div>
						</div>
						<div class="descripcion">
							<span class="descripcion-title">Descripción</span>
							<!-- <span class="descripcion-content">{{ espectaculo.descripcion }}</span> -->
							<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
						</div>
					</div>
				</div>
				<div class="transferencia-right">
					<div class="resumen-header">
						<h1>Resumen</h1>
						<p>Detalles de tu transferencia de butaca</p>
					</div>
					<div class="resumen-listado">
						<div class="resumen-ticket">
							<div class="resumen-ticket-left">
								<span class="ticket-nro">Transferencia de butaca</span>
								<span v-if="acreedor.nombre && acreedor.apellido && acreedor.documento && duenio.documento && duenio.butacaNro">Butaca {{ duenio.butacaNro }}</span>
								<span v-if="acreedor.nombre && acreedor.apellido && acreedor.documento && duenio.documento && duenio.butacaNro">{{ acreedor.nombre }} {{ acreedor.apellido }} &bull; {{ acreedor.documento }}</span>
								<span v-else>Completa la información de la transferencia</span>
							</div>
							<div class="resumen-ticket-right" v-if="acreedor.nombre && acreedor.apellido && acreedor.documento && duenio.documento && duenio.butacaNro">$ 0</div>
							<div class="resumen-ticket-right" v-else>-</div>
						</div>
						<div class="resumen-total">
							<span class="label">Total a pagar</span>
							<!-- <span class="total" v-if="acreedor.nombre && acreedor.apellido && acreedor.documento && duenio.documento && duenio.butacaNro">Gratis</span> -->
							<span class="total" v-if="datosCompletos">Gratis</span>
							<span class="total" v-else>-</span>
						</div>
					</div>
					<div class="acciones-aside">
						<div class="acciones-aside-botones">
							<button @click="transferir" :disabled="!datosCompletos">Transferir butaca</button>
						</div>
					</div>
					<div class="cancelar-transferencia">
						<router-link :to="{ name: 'espectaculo', params: { espectaculoId: Number(this.$route.params.espectaculoId) } }">Cancelar transferencia</router-link>
					</div>
				</div>
				<p style="margin-bottom: 10px;" class="mobile-info-title">Información del espectáculo</p>
				<div class="info-espectaculo mobile-info-main">
					<div class="competencia">
						<div class="competencia-info">
							<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
							<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
						</div>
						<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
					</div>
					<div class="fecha" v-if="espectaculo.requiereInstituciones">
						<span class="fecha-title">Fecha</span>
						<div class="fecha-content">
							<div class="fecha-texto">
								<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
								<p>{{ espectaculo.fechaEscrita }}</p>
							</div>
							<div class="fecha-hora">
								{{ espectaculo.hora }}
							</div>
						</div>
					</div>
					<div class="lugar">
						<span class="lugar-title">Lugar</span>
						<div class="lugar-content">
							<div class="lugar-content-left">
								<div class="lugar-info">
									<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
									<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
								</div>
								<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre" v-if="espectaculo.escenarioLogo">
							</div>
							<div class="ver-mapa" content="Ver ubicación" tabindex="-1" v-tippy="{ placement : 'bottom'}">
								<a :href="espectaculo.escenarioMapaURL" tabindex="-1" target="_blank"><map-icon></map-icon></a>
							</div>
						</div>
					</div>
					<div class="descripcion">
						<span class="descripcion-title">Descripción</span>
						<!-- <span class="descripcion-content">{{ espectaculo.descripcion }}</span> -->
						<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { MapIcon, InfoIcon } from 'vue-feather-icons'

	export default {
		data(){
			return {
				usuarioId: localStorage.getItem('usuario_id'),
				espectaculo: {
					id: null,
					nombre: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					fechaDiaSemanaEscrito: '',
					hora: '',
					escenarioNombre: '',
					escenarioDireccion: '',
					escenarioLogo: '',
					escenarioSVG: '',
					escenarioMapaURL: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					descripcion: ''
				},
				preseleccionPersona: {
					personaId: 0, 
					personaPreText: null,
					personaNombre: null,
					personaApellido: null,
					personaDocumentoTipo: null,
					personaDocumento: null,
					personaSocioNro: null,
					personaDocumentoTipoAbr: null,
					personaTelefono: null,
					descripcion: '(No utilizar preselección de persona)'
				},
				preselecciones: [],
				esPreseleccion: false,
				tipoDocumentos: [],
				tipoDocumentoCI: null,
				duenio: {
					documentoTipo: null,
					documento: '',
					butacaNro: '',
					pin: ''
				},
				acreedor: {
					personaId: 0,
					nombre: '',
					apellido: '',
					documentoTipo: null,
					documento: '',
					telefono: ''
				},
				hayError: false,
				errorMsg: '',
				transfiriendo: false,
				transaccionId: null,

				// Datos del ticket
				// -- de momento, datos de prueba
				tribuna: 2,
				sector: 'ATI-04',
				filasAsientos: [{
					asiento: 4,
					fila: 1
				}]
			}
		},
		components: {
			MapIcon,
			InfoIcon
		},
		computed: {
			loggedIn(){
				return this.$store.getters.loggedIn
			},
			// isDisabledTransferir(){
			// 	if(this.acreedor.nombre && this.acreedor.apellido && this.acreedor.documento && this.acreedor.telefono && this.duenio.documento && this.duenio.butacaNro){
			// 		return false;
			// 	} else {
			// 		return true;
			// 	}
			// },
			datosCompletos: function(){
				if(this.acreedor.nombre.trim().length <= 2 || this.acreedor.apellido.trim().length <= 2 || this.acreedor.documento.trim().length <= 3 || this.duenio.documento.trim().length <= 3 || this.duenio.butacaNro.length <= 3 || this.duenio.pin.length !== 4){
					return false;
				} else {
					return true;
				}
			}
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			
			if(this.loggedIn === false){
				this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
			}
			
			await this.espectaculoConButaquistas();
			await this.cargoEspectaculo();
			await this.tiposDocumento();
			await this.cargoPreselecciones();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async espectaculoConButaquistas(){
				// Valido que el espectáculo admita butaquistas
				try {
					let response = await axios.post('/WSEspectaculoConButaquistas', { EspectaculoId: Number(this.$route.params.espectaculoId) });

					if(response.data.ErrorCod !== 0){
						this.$router.push({ name: 'error' });
					} else {
						if(response.data.ConButaquistas === false){
							this.$router.push({ name: 'error' });
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async tiposDocumento(){
				// Obtengo tipos de documento
				try {
					let response = await axios.post('/WSDocumentoTipoCortesiaPalco', {});

					for(var o=0; o<response.data.SDTDocumentoTipo.length; o++){
						this.tipoDocumentos.push({ valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre });

						if(Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre }
							this.duenio.documentoTipo = this.tipoDocumentoCI;
							this.acreedor.documentoTipo = this.tipoDocumentoCI;
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async cargoEspectaculo(){
				// Obtengo espectáculo
				try {
					let response = await axios.post('/WSEspectaculo', { 'EspectaculoId' : Number(this.$route.params.espectaculoId) });

					if(response.data.ErrorCod === 0){
						var data = response.data.SDTEspectaculo;

						this.espectaculo.id = Number(data.EspectaculoId);
						this.espectaculo.nombre = data.EspectaculoNombre;
						this.espectaculo.tipoId = Number(data.EspectaculoTipoId);
						this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculo.tipoColor = data.EspectaculoTipoColor;
						this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
						this.espectaculo.hora = data.EspectaculoHora;
						this.espectaculo.escenarioNombre = data.EscenarioNombre;
						this.espectaculo.escenarioDireccion = data.EscenarioDireccion;
						this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
						this.espectaculo.competenciaNombre = data.CompetenciaNombre;
						this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculo.descripcion = data.EspectaculoDescripcion;
					} else {
						// Redirigir a 404 (no se encontró espectáculo)
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async transferir(){
				this.$store.dispatch('cargando', true);
				await this.validacionDatos();

				if(this.hayError === false){
					this.transfiriendo = true;

					let response = await axios.post('/WSTransferenciaTicket', {
						UsuarioId: this.usuarioId,
						EspectaculoId: Number(this.espectaculo.id), 
						ButaquistaDocumentoTipoId: Number(this.duenio.documentoTipo.valor), 
						ButaquistaDocumento: this.duenio.documento, 
						ButacaRegistroCodigo: this.duenio.butacaNro,
						ButacaRegistroPIN: this.duenio.pin,
						PersonaDocumentoTipoId: Number(this.acreedor.documentoTipo.valor), 
						PersonaDocumento: this.acreedor.documento, 
						PersonaNombre: this.acreedor.nombre, 
						PersonaApellido: this.acreedor.apellido, 
						// PersonaTelefono: this.acreedor.telefono
						PersonaTelefono: ''
					}, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`}});

					if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
						this.$store.dispatch('cargando', false);
						this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							// Transferencia realizada correctamente
							this.$store.dispatch('cargando', false);
							this.$router.push({ name: 'espectaculo-transferencia-fin', params: { isOk: 'isok' } })
						} else {
							this.$store.dispatch('cargando', false);
							this.hayError = true
							this.$store.dispatch('mostrarError', response.data.ErrorDsc)
						}
					}
				} else {
					this.$store.dispatch('mostrarError', this.errorMsg)
				}

				this.$store.dispatch('cargando', false);
			},
			async validacionDatos(){
				this.hayError = false

				if(this.duenio.documento.trim().length <= 1){
					this.hayError = true
					this.errorMsg = 'Ingrese documento del titular de la butaca'
				}

				if(this.duenio.butacaNro.length <= 3){
					this.hayError = true
					this.errorMsg = 'Código de butaca incorrecto'
				}

				if(this.duenio.pin.length !== 4){
					this.hayError = true
					this.errorMsg = 'PIN de butaca incorrecto. Debe tener 4 dígitos.'
				}

				if(this.acreedor.nombre.trim().length <= 1){
					this.hayError = true
					this.errorMsg = 'Ingrese nombre del beneficiario'
				}

				if(this.acreedor.apellido.trim().length <= 1){
					this.hayError = true
					this.errorMsg = 'Ingrese apellido del beneficiario'
				}

				if(this.acreedor.documento.trim().length <= 1){
					this.hayError = true
					this.errorMsg = 'Ingrese documento del beneficiario'
				}

				// if(!this.acreedor.telefono){
				// 	this.hayError = true
				// 	this.errorMsg = 'Ingrese teléfono del beneficiario'
				// }

				// if(this.acreedor.telefono.length < 8 || this.acreedor.telefono.length > 20){
				// 	this.hayError = true
				// 	this.errorMsg = 'Teléfono incorrecto'
				// }

				// Chequeo que los documentos no sean los mismos
				if(this.duenio.documento.trim() === this.acreedor.documento.trim()){
					this.hayError = true
					this.errorMsg = 'Documentos del titular y beneficiario no pueden coincidir'
				}
			},
			async cambioPreseleccion(){
				var preseleccionPersona;
				if(Number(this.preseleccionPersona.personaId) !== 0){
					this.esPreseleccion = true

					preseleccionPersona = this.preselecciones.find(p => Number(p.personaId) === Number(this.preseleccionPersona.personaId));

					for(let n=0; n<this.tipoDocumentos.length; n++){
						if(Number(preseleccionPersona.personaDocumentoTipo) === Number(this.tipoDocumentos[n].valor)){
							this.acreedor.documentoTipo = this.tipoDocumentos[n];
							break;
						}
					}

					this.acreedor.personaId = preseleccionPersona.personaId
					this.acreedor.nombre = preseleccionPersona.personaNombre
					this.acreedor.apellido = preseleccionPersona.personaApellido
					this.acreedor.documento = preseleccionPersona.personaDocumento
					this.acreedor.telefono = preseleccionPersona.personaTelefono
					//this.acreedor.guardarInformacionPersona = false

					//await this.calcularCategoriaSocio();
				} else {
					this.esPreseleccion = false
				}
			},
			async cargoPreselecciones(){
				// Cargo las preselecciones de personas
				try {
					let response = await axios.post('/WSPersonasListar', { UsuarioId: this.usuarioId }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} })
					
					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							let preseleccion;
							let sdtPersonas = response.data.SDTPersona;
							let preText;

							preseleccion = {
								personaId: 0, 
								personaPreText: null,
								personaNombre: null,
								personaApellido: null,
								personaDocumentoTipo: null,
								personaDocumento: null,
								personaSocioNro: null,
								personaDocumentoTipoAbr: null,
								personaTelefono: null,
								descripcion: '(No utilizar preselección de persona)'
							}
							this.preselecciones.push(preseleccion);

							for(var i=0; i<sdtPersonas.length; i++){
								if(i === 0){
									// Es la persona del usuario
									preText = 'Yo: '
								} else {
									preText = ''
								}

								let dsc = '';

								dsc = preText + ' ' + sdtPersonas[i].PersonaNombre + ' ' + sdtPersonas[i].PersonaApellido + ' - ' +  sdtPersonas[i].PersonaDocumentoTipoAbreviacion + ' ' + sdtPersonas[i].PersonaDocumento

								preseleccion = {
									personaId: sdtPersonas[i].PersonaId, 
									personaPreText: preText,
									personaNombre: sdtPersonas[i].PersonaNombre, 
									personaApellido: sdtPersonas[i].PersonaApellido, 
									personaDocumentoTipo: sdtPersonas[i].PersonaDocumentoTipoId, 
									personaDocumento: sdtPersonas[i].PersonaDocumento, 
									personaSocioNro: sdtPersonas[i].PersonaSocioNro, 
									personaDocumentoTipoAbr: sdtPersonas[i].PersonaDocumentoTipoAbreviacion,
									personaTelefono: sdtPersonas[i].PersonaTelefono,
									descripcion: dsc
								}
								this.preselecciones.push(preseleccion);
							}
						} else {
							// Redirigir a 404 (no se encontró espectáculo)
							this.$router.push({ name: 'error' });
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			}
		}
	}
</script>

<style lang="scss">
	.transferencia-butaca-page{
		.multiselect {
    		min-height: 37px;
		}

		.multiselect__select{
			height: 37px;
		}

		.multiselect__input, .multiselect__single{
			margin: 0;
			font-size: 15px;
			line-height: 22px;
			font-weight: var(--font-weight-bold);
			-webkit-letter-spacing: 0;
			-moz-letter-spacing: 0;
			-ms-letter-spacing: 0;
			letter-spacing: 0;
			color: var(--color-dark);
			font-family: var(--font-family-poppins);
			text-transform: uppercase;
			padding-left: 0;
		}

		.multiselect__tags{
			min-height: 37px;
			font-size: 15px;
			line-height: 22px;
			padding-top: 7px;
			padding-bottom: 7px;
		}

		.multiselect--disabled{
			background: transparent;
		}

		.multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select{
			background: transparent;
			color: var(--color-grey);
		}

		.multiselect--disabled{
			opacity: 1;
		}

		.multiselect--disabled .multiselect__input, .multiselect--disabled .multiselect__single{
			color: var(--color-grey);
		}
	}
</style>

<style lang="scss" scoped>
	.transferencia-butaca-page{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.transferencia-butaca-header{
			padding-top: 76px;
			width: 100%;
			position: relative;
			height: 260px;
			background: url('../../assets/sports-player-background.jpg');
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			@include flex(column, flex-start, center);

			.container{
				height: 100%;
				margin: 0;
				width: 100%;
				@include flex(column, flex-end, center);

				max-width: 1260px;
				padding: 0px 16px;
				z-index: 1;
				padding-bottom: 10px;
				@include flex(column, flex-end, flex-start);
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: var(--color-white);
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							line-height: 1.1em;
							color: var(--color-white);
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
						}

						&.header-equipo-local{
							span{
								font-size: 32px;

								&.vs{
									font-family: var(--font-family-poppins);
									line-height: 1em;
									color: var(--color-blue-light);
									font-size: 24px;
									margin-left: 10px;
									margin-top: 6px;
									font-weight: var(--font-weight-bold);
								}
							}

							.header-escudo{
								height: 39px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{
							margin-top: 5px;
							
							span{
								font-size: 30px;
							}

							.header-escudo{
								height: 34px;
								width: auto;
								margin-right: 10px;
								margin-left: 3px;
							}
						}
					}
				}
			}
		}

		.transferencia-butaca-main{
			width: 100%;
			position: relative;
			margin: 64px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1260px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.transferencia-left{
					width: calc(64% - 16px);
					background-color: var(--color-white);
					padding: 0px;

					h1{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}

					.transferencia-content-row{
						margin: 20px 0;
						padding: 0;
						@include flex(column, flex-start, center);

						.butaca-dueno{
							&:after{
								content: 'Titular';
								background-color: var(--color-blue);
							}
						}

						.butaca-acreedor{
							&:after{
								content: 'Beneficiario';
								background-color: var(--color-red);
							}
						}

						.butaca-dueno, .butaca-acreedor{
							position: relative;
							border-radius: 0;
							-webkit-box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							width: 100%;
							padding: 20px;
							padding-left: 70px;
							background-color: var(--color-white);
							position: relative;

							&:after{
								position: absolute;
								top: 0px;
								left: 0px;
								width: 50px;
								height: 100%;
								@include flex(row, center, center);
								color: var(--color-white);
								writing-mode:vertical-lr;
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								-webkit-letter-spacing: 2px;
								-moz-letter-spacing: 2px;
								-ms-letter-spacing: 2px;
								letter-spacing: 2px;
								font-size: 13px;
							}

							.nro-ticket{
								padding: 4px 8px;
								border-radius: 99px;
								background-color: #f3f3f9;
								font-weight: 400;
								line-height: 1em;
								letter-spacing: 1px;
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 12px;
							}

							.row{
								margin: 12px 0;
								@include flex(row, space-between, center);

								.row-group{
									width: 50%;
									padding: 0px 8px 8px 8px;
									margin: 0;
									@include flex(column, center, flex-start);
									position: relative;

									&:first-child{
										padding-left: 0px;
									}

									&:last-child{
										padding-right: 0px;
									}

									span.label{
										font-size: 14px;
										font-weight: var(--font-weight-regular);
										color: var(--color-grey);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 17px;
										font-family: var(--font-family-fira);
										@include flex(row, flex-start, center);

										svg{
											margin-left: 5px;
											cursor: pointer;
											width: 14px;
											height: auto;
											margin-top: -1px;

											&:focus{
												outline: none;
											}
										}
									}

									span.campo{
										@include flex(column, center, flex-start);
										font-size: 15px;
										line-height: 22px;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 7px;
										padding-bottom: 7px;

										&.campo-small{
											font-family: var(--font-family-poppins);
											color: var(--color-grey);
											font-size: 12px;
											font-weight: 400;
										}
									}

									p{
										margin: 0;
										line-height: 1.3em;
										font-size: 12px;
									}

									input{
										font-size: 15px;
										line-height: 22px;
										border-bottom: 1px solid var(--color-grey-light);
										display: block;
										width: 100%;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 7px;
										padding-bottom: 7px;

										&:focus{
											border-color: var(--color-blue);
										}

										&:disabled{
											-webkit-text-fill-color: var(--color-grey);
											-webkit-opacity: 1;
											opacity: 1;
											color: var(--color-grey);
										}
									}

									&.row-group-100{
										width: 100%;
									}

									&.row-group-footer{
										width: 100%;
										@include flex(row, flex-start, center);

										input{
											width: auto;
											margin: 0;
											margin-right: 8px;
										}

										label{
											line-height: 1.3em;
											font-size: 12px;
											margin: 0;
										}
									}

									.small-text{
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-grey);
										font-family: var(--font-family-fira);
										font-size: 11px;
										line-height: 1.4em;
										padding: 0px 10px;
									}
								}

								&.row-border-bottom{
									margin-top: 0px;
									border-bottom: 1px dashed #d3d3dc;
									padding-bottom: 14px;

									.row-group{
										width: auto;
									}
								}

								&.solo-sector{
									justify-content: flex-start !important;

									.row-group{
										margin-right: 20px;
									}
								}

								&.row-info{
									@include flex(column, center, flex-start);
								}

								span.title{
									margin: 0;
									font-size: 13px;
									line-height: 20px;
									margin-bottom: 0px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								&:last-child{
									margin-bottom: 0;
								}

								span.atencion-pin{
									padding: 4px 8px;
									border-radius: 4px;
									background-color: #f3f3f9;
									font-weight: 400;
									line-height: 1.3em;
									letter-spacing: 1px;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-semibold);
									text-transform: uppercase;
									font-size: 12px;
									border: 1px solid var(--color-grey-light);
								}
							}
						}

						.switch{
							width: 50px;
							height: 50px;
							padding: 8px;
							background: var(--color-blue-dark);
							transform: rotate(90deg);
							border-radius: 6px;
							margin: 15px 0;
							
							img{
								width: 100%;
								height: auto;
							}
						}
					}
				}

				.transferencia-right{
					top: 102px;
					position: sticky;
					margin-top: 86px;
					width: calc(36% - 16px);
					border-radius: 0px;
					padding: 0;
					background-color: var(--color-grey-lighter);

					.resumen-header{
						width: 100%;
						padding: 20px 20px 0 20px;

						h1{
							margin: 0;
							text-transform: uppercase;
							color: var(--color-red);
							font-family: var(--font-family-kapra-bold);
							font-size: 36px;
							-webkit-letter-spacing: -0.3px;
							-moz-letter-spacing: -0.3px;
							-ms-letter-spacing: -0.3px;
							letter-spacing: -0.3px;
							line-height: 1em;
							margin-bottom: 5px;
						}

						p{
							margin: 0;
							color: var(--color-blue-dark);
							font-family: var(--font-family-fira);
							font-weight: var(--font-weight-bold);
							font-size: 16px;
							line-height: 18px;
							margin-bottom: 15px;
						}
					}

					.resumen-listado{
						width: 100%;
						padding: 0 20px;
						margin: 5px 0;
						@include flex(column, flex-start, flex-start);

						.resumen-ticket{
							width: 100%;
							@include flex(row, space-between, center);
							border-bottom: 1px solid #e4e4ef;
							margin: 4px 0px;
							padding: 4px 0 8px 0;

							.resumen-ticket-left{
								@include flex(column, center, flex-start);

								span{
									font-family: var(--font-family-fira);
									font-size: 14px;
									line-height: 21px;
									color: var(--color-grey);

									&.ticket-nro{
										margin: 0;
										font-size: 13px;
										line-height: 20px;
										margin-bottom: 5px;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
									}
								}
							}

							.resumen-ticket-right{
								@include flex(column, center, flex-end);

								margin: 0;
								font-size: 15px;
								line-height: 20px;
								margin-bottom: 0px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}
						}

						.resumen-total{
							width: 100%;
							@include flex(row, space-between, center);
							margin: 5px 0;

							span.label{
								margin: 0;
								font-size: 14px;
								line-height: 20px;
								margin-bottom: 0px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-red);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							span.total{
								margin: 0;
								font-size: 14px;
								line-height: 20px;
								margin-bottom: 0px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-red);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}
						}
					}

					.acciones-aside{
						padding: 15px 20px 20px 20px;
						width: 100%;
						margin: 0;

						.acciones-aside-botones{
							width: 100%;
							margin: 0;
							@include flex(row, space-between, center);

							button{
								width: 100%;
								@include flex(row, center, center);
								text-transform: uppercase;
								font-family: var(--font-family-poppins);
								font-weight: var(--font-weight-bold);
								position: relative;
								cursor: pointer;
								width: 100%;
								background-color: var(--color-red);
								color: var(--color-white);
								-webkit-transition: background-color .2s ease;
								transition: background-color .2s ease;
								-webkit-letter-spacing: 1px;
								-moz-letter-spacing: 1px;
								-ms-letter-spacing: 1px;
								letter-spacing: 1px;
								// min-height: 48px;
								padding: 12px 24px;
								font-size: 14px;
								line-height: 20px;
								-webkit-font-smoothing: antialiased;
								-moz-osx-font-smoothing: grayscale;
								outline-color: transparent;
								outline: none;
								box-shadow: none;
								border: 0;
								margin: 0;

								&:hover{
									background-color: var(--color-blue-dark);
								}

								&:disabled{
									color: var(--color-dark);
									background-color: var(--color-grey-light);
									cursor: not-allowed;
								}
							}
						}
					}

					.cancelar-transferencia{
						width: 100%;
						@include flex(row, center, center);
						margin-bottom: 20px;

						a{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							// font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-grey);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
							text-decoration: none;
							transition: all .2s;

							&:hover{
								color: var(--color-dark);
							}
						}
					}
				}

				.mobile-info-title, .full-info-title{
					margin: 0;
					font-size: 18px;
					line-height: 26px;
					font-family: var(--font-family-fira);
					font-weight: bold;
					color: var(--color-dark);
				}

				.mobile-info-title{
					display: none;
				}

				.info-espectaculo{
					border-radius: 8px;
					border: 1px solid #d3d3dc;
					@include flex(column, flex-start, flex-start);

					&.mobile-info-main{
						display: none;
					}
					
					.competencia{
						border-radius: 0px;
						border: none;
						padding: 20px;
						border-bottom: 1px solid #d3d3dc;
						width: 100%;
						@include flex(row, space-between, center);

						.competencia-info{
							@include flex(column, center, flex-start);

							span.competencia-nombre{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 0px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							span.competencia-instancia{
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}

						img{
							height: 32px;
							width: auto;
							margin-left: 15px;
						}
					}

					.fecha{
						border-radius: 0px;
						border: none;
						padding: 20px;
						border-bottom: 1px solid #d3d3dc;
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.fecha-title{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							margin-bottom: 2px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-dark);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
						}

						.fecha-content{
							width: 100%;
							@include flex(row, space-between, center);

							.fecha-texto{
								@include flex(column, center, flex-start);

								p{
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 15px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
									margin: 0;
								}
							}

							.fecha-hora{
								height: 100%;
								margin-left: 14px;
								border-left: 1px solid #d3d3dc;
								padding: 10px 0 10px 14px;
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 21px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}
					}

					.lugar{
						border-radius: 0px;
						border: none;
						padding: 20px;
						border-bottom: 1px solid #d3d3dc;
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.lugar-title{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							margin-bottom: 2px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-dark);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
						}

						.lugar-content{
							@include flex(row, space-between, center);
							width: 100%;

							.lugar-content-left{
								@include flex(row, flex-start, center);

								.lugar-info{
									padding-right: 12px;
									// border-right: 1px solid #d3d3dc;
									@include flex(column, center, flex-start);

									span.lugar-escenario{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 20px;
									}

									span.lugar-direccion{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 13px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 18px;
									}
								}

								img{
									width: 28px;
									height: auto;
									margin-left: 12px;
								}
							}

							.ver-mapa{
								@include flex(column, center, center);
								margin-left: 12px;

								a{
									background-color: transparent;
									border: 1px solid var(--color-blue-darker);
									padding: 6px;
									text-decoration: none;
									@include flex(row, center, center);
									transition: all .2s;
									border-radius: 99px;

									svg{
										width: 15px;
										height: auto;
										transition: all .2s;
										color: var(--color-blue-darker);
									}

									&:hover{
										background-color: var(--color-blue-darker);

										svg{
											color: var(--color-white);
										}
									}
								}
							}
						}
					}

					.descripcion{
						border-radius: 0px;
						border: none;
						padding: 20px;
						width: 100%;
						@include flex(column, flex-start, flex-start);
						
						.descripcion-title{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							margin-bottom: 2px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-dark);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
						}

						.descripcion-content{
							color: var(--color-dark);
							font-family: var(--font-family-fira);
							font-weight: var(--font-weight-regular);
							font-size: 15px;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							line-height: 20px;
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and(max-width: 910px){
		.transferencia-butaca-page{
			.transferencia-butaca-header{
				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 24px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 32px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							font-size: 18px;
							margin-left: 8px;
							margin-top: 3px;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 28px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}

			.transferencia-butaca-main{
				margin: 30px 0;
				.container{
					@include flex(column, flex-start, flex-start);

					.transferencia-left{
						width: 100%;

						.full-info-title, .full-info-main{
							display: none;
						}

						p{
							font-size: 16px;
						}

						h1{
							font-size: 29px;
							line-height: 23px;
						}
					}

					.mobile-info-title{
						display: block;
						margin-top: 20px;
						font-size: 16px;
					}
					
					.info-espectaculo{
						&.mobile-info-main{
							@include flex(column, flex-start, flex-start);
							width: 100%;
						}
					}

					.transferencia-right{
						margin-top: 0px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 590px){
		.transferencia-butaca-page{
			.transferencia-butaca-main{
				.container{
					.transferencia-left{
						.transferencia-content-row{
							.butaca-acreedor, .butaca-dueno{
								padding-left: 60px;

								.row{
									@include flex(column, flex-start, flex-start);

									.row-group{
										width: 100%;
										padding: 0px;
										padding-bottom: 5px;

										span.label{
											font-size: 14px;
											line-height: 17px;
										}

										span.campo{
											font-size: 14px;
											line-height: 20px;
										}

										input{
											font-size: 14px;
											line-height: 20px;
										}

										.small-text{
											padding-left: 0px;
										}
									}
								}

								&:after{
									width: 40px;
									height: 100%;
								}

								&:before{
									width: 40px;
									height: 40px;
									font-size: 13px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 490px){
		.transferencia-butaca-page{
			.transferencia-butaca-header{
				height: 250px;

				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 20px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 30px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							display: none;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 26px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}
		}
	}
</style>